<template class="full-height">
  <div class="app-position-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      modal-append-to-body
      append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`【${currentUser.name}】 旅客回傳紀錄`"
      :visible.sync="dialogUserVisible"
      width="40%"
      v-if="currentUser && currentUserRecord.length > 0"
    >
      <el-card class="box-card">
        <div>
          <el-table
            v-loading="listLoading"
            size="mini"
            :data="currentUserRecord"
            border
            fit
            highlight-current-row
            height="500px"
          >
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="日期" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.recordDate }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="funcName + '座標緯度'" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.lat }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="funcName + '座標經度'" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.lng }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="'地圖'" width="170">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.lat && scope.row.lng"
                  size="mini"
                  @click="googleMap(scope.row)"
                  icon="el-icon-position"
                  type="success"
                  >查看Google地圖</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="`【${currentTravelName}】 旅遊團旅客最新經緯度回傳紀錄`"
      :visible.sync="dialogVisible"
      width="70%"
      v-if="currentTravelers && currentTravelers.length > 0"
    >
      <el-card class="box-card">
        <div>
          <el-table
            v-loading="listLoading"
            size="mini"
            :data="currentTravelers"
            border
            fit
            highlight-current-row
            height="100%"
          >
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="日期" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.recordDate }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="userAccount" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.account }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="userName" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="funcName + '座標緯度'" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.lat }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="funcName + '座標經度'" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.lng }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="明細" width="120">
              <template slot-scope="scope">
                <el-button type="primary" @click="getUserPosition(scope.row)">明細</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'地圖'" width="170">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.lat && scope.row.lng"
                  size="mini"
                  @click="googleMap(scope.row)"
                  icon="el-icon-position"
                  type="success"
                  >查看Google地圖</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <!-- <el-form-item label="代碼查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入景點名稱" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-alert show-icon closable="false" type="info"
            >經緯度資料系統保留7天內資紀錄</el-alert
          > -->
        </el-form-item>
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="日期" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.recordDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團ID" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.travelID }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團名" width="400">
          <template slot-scope="scope">
            <span>{{ scope.row.travelName }}</span>
          </template>
        </el-table-column>
        <!-- 
        <el-table-column align="center" label="userAccount" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userAccount }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="userName" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="funcName + '座標緯度'"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lat }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="funcName + '座標經度'"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lng }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="查看" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { saveViewPoint } from '@/api/travel'

import { getAppPositionTravelLog, getAppPositionTravelLogByID, getUserPosition } from '@/api/system'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'AppPosition',
  components: {
    Pagination,
  },
  data() {
    return {
      currentUser: null,
      dialogUserVisible: false,
      currentUserRecord: [],
      currentTravelID: null,
      currentTravelName: null,
      currentTravelers: [],
      funcName: '景點',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-travelID',
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async getUserPosition(row) {
      let resp = await getUserPosition({
        travelID: this.currentTravelID,
        userID: row.userID,
      })
      if (resp.data.length == 0) {
        this.currentUserRecord = []
        alert('查無資料。')
      } else {
        this.currentUser = row
        this.currentUserRecord = resp.data
        this.dialogUserVisible = true
      }
    },
    addData() {
      this.dialogVisible = true
    },
    async editData(row) {
      this.form = row
      let resp = await getAppPositionTravelLogByID({ travelID: row.travelID })
      // console.log(resp);
      this.currentTravelID = row.travelID
      this.currentTravelName = row.travelName
      this.currentTravelers = resp.data.travelers
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let resp = await saveViewPoint(this.form)
          await vm.getList()
          this.dialogVisible = false
          vm.dialogLoading = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getAppPositionTravelLog(this.listQuery)
      this.list = resp.data.data
      // console.log(this.list);
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
